import React from 'react'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap'
import ReactInputMask from 'react-input-mask'
import { useDispatch, useSelector } from 'react-redux'
import { DateTime } from 'luxon'

import { updateSite } from '../../../utils/Organizations'
import { appendModel } from '../../../../features/site/siteSlice'
import { BUSINESS_CATEGORIES } from '../../../utils/common'

function Customizations(){
    const dispatch = useDispatch()
    const model = useSelector(state => state.site.model)
    const updateGoals = async(e) => {        
        const site = model?.sites[model?.siteActiveIdx]
        const yyyy = DateTime.local().toFormat("yyyy")

        let sForm = {
            ...siteForm,
            attr: {
                ...siteForm.attr,  
                initSite: true, 
                unitSales: {
                    ...(siteForm.attr.unitSales ?? {}),
                    goals: {
                        ...(siteForm?.attr?.unitSales?.goals ?? {}),
                        [yyyy]: {
                            ...(siteForm?.attr?.unitSales?.goals ? siteForm?.attr?.unitSales?.goals[yyyy] : {}),
                            [e.target.name]: parseFloat(e.target.value)
                        }
                    }
                }
            }
        }

        await dispatch(appendModel({
            sites: [sForm],
            siteForm: {...sForm}
        }))

        const { response, error } = await updateSite(site.siteId, null, {
            site: {...sForm}
        })
    }

    const changeSiteForm = async(e) => {
        const [fName, sName] = e.target.name.split(".")
        const sForm = {
            ...siteForm,
            [fName]: {
                ...siteForm[fName],
                [sName]: e.target.value
            }
        }

        await dispatch(appendModel({
            siteForm: {
                ...sForm, 
                attr: {
                    ...sForm.attr,  
                    initSite: true
                }
            }
        }))
        
        await updateSite(siteForm.siteId, null, {
            site: {
                ...sForm, 
                attr: {
                    ...sForm.attr,  
                    initSite: true
                }
            }
        })
    }

    const { siteForm } = model

    const site = model?.sites[model?.siteActiveIdx]
    const now = DateTime.local()
    const goals = siteForm?.attr?.unitSales ? siteForm?.attr?.unitSales?.goals[now.toFormat("yyyy")] : {}

    return <>
        <h4>Please let us know your timezone and category of business:</h4> 
        <Row form>
            <Col md="6" lg="6">
                <FormGroup>
                    <Label htmlFor="tz">Timezone</Label>
                    <select className="form-control" name="attr.timezone" value={siteForm.attr.timezone} onChange={changeSiteForm}>
                        <option></option>
                        <option value="Samoa">Samoa</option>
                        <option value="Hawaii-Aleutian">Hawaii-Aleutian</option>
                        <option value="Alaska">Alaska</option>
                        <option value="Pacific">Pacific</option>
                        <option value="Mountain">Mountain</option>
                        <option value="Central">Central</option>
                        <option value="Eastern">Eastern</option>
                        <option value="Atlantic">Atlantic</option>
                    </select>
                </FormGroup>
            </Col>
            <Col md="6" lg="6">
                <FormGroup>
                    <Label htmlFor="businessType">Business Category</Label>
                    <Input type="select" name="attr.businessType" onChange={changeSiteForm} value={siteForm?.attr?.businessType}>
                        <option></option>
                        {BUSINESS_CATEGORIES.map(category => <option key={category} value={category}>
                            {category}
                        </option>)}
                    </Input>
                </FormGroup>
            </Col>
        </Row>
        <h4>Interested in a free trial of our Revenue Tracker? If so, complete the following:</h4> 
        <Row form>
            <Col md="6" lg="6">
                <label for="revenueGoals">
                    {now.toFormat("yyyy")} Revenue Goals
                </label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="revenueGoalPrepend">$</span>
                    </div>
                    <input type="number" min="0" class="form-control" id="revenueGoal" aria-describedby="revenueGoalPrepend" name="revenue" onChange={updateGoals} value={parseFloat(goals?.revenue ?? 0)} />
                </div>
            </Col>
            <Col md="6" lg="6">
                <label for="unitSalesGoals">
                    {now.toFormat("yyyy")} Unit Sales Goals
                </label>
                <input type="number" min="0" class="form-control" id="unitGoal" name="units" onChange={updateGoals} value={parseInt(goals?.units ?? 0)} />
            </Col>
        </Row>
        <h4 className="mt-4">If you're not ready for revenue saving alerts or tracking daily revenue targets, those can be entered in later.</h4> 
    </>
}

export default Customizations